<template>
  <div>
    <div class="fixed-top">
      <LobbyNavbar />
    </div>

    <div class="container" style="margin-top:88px">
      <p>&zwnj;</p>
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/Home">
              <span class="text-primary">
                Home
              </span>
            </router-link>
          </li>

          <li class="breadcrumb-item">
            <router-link to="/Events">
              <span class="text-primary">
                Online Events
              </span>
            </router-link>
          </li>

          <li class="breadcrumb-item">
            <router-link to="/Association">
              <span class="text-primary">
                Association Center
              </span>
            </router-link>
          </li>

          <li class="breadcrumb-item active" aria-current="page">{{ URLAssoID }}</li>
        </ol>
      </nav>
      <p>&zwnj;</p>

      <!-- 0. Vietnam Plastics Association -->

      <div v-if="URLAssoID == 'VietnamPlasticsAssociation'">
        <span class="title_fontStyle my-5 h2"> <i class="fas fa-caret-right"></i> Welcome Message </span>

        <div class="my-4 ">
          <div class="row  align-items-center px-4 pb-4">
            <div class="col-lg-4 text-center mb-2">
              <a
                href="https://www.chanchao.com.tw/vietnamplasprintpack/onlineexpo/ExhibitorDetail/27CB21BD6EDBCBFEF20195FE647A48EE"
                target="_blank"
              >
                <div class="logImgFrame_ExhInfo">
                  <img
                    src="../../assets/images/Association_VPA_1.jpg"
                    width="70%"
                    alt=""
                    class="mb-2"
                    @click="saveToExh('27CB21BD6EDBCBFEF20195FE647A48EE')"
                  />
                </div>
              </a>
            </div>
            <div class="col-lg-8 text-lg-left text-center BannerHover" @click.prevent="OpenAssoDetail('OrganMessage')">
              <h3>Vietnam Plastics Association</h3>

              <p class="mt-2">
                Vietnam’s plastic industry plays an extremely important role in the economic development…
              </p>

              <p class="mt-3 text-primary">
                Read more
                <span class="ml-1"><i class="fas fa-angle-double-right " style="font-size:12px"></i></span>
              </p>
            </div>
          </div>
        </div>

        <div>
          <span class="title_fontStyle my-5 h2"> <i class="fas fa-caret-right"></i> Exclusive Members </span>

          <div class="row align-items-center p-4 my-5">
            <div class="col-lg-4 text-center mb-2">
              <div class="logImgFrame_ExhInfo">
                <a
                  href="https://www.chanchao.com.tw/vietnamplasprintpack/onlineexpo/ExhibitorDetail/27CB21BD6EDBCBFEF20195FE647A48EE"
                  target="_blank"
                >
                  <img
                    :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${ExhInfo_Asso_0.ComLogo}`"
                    width="70%"
                    alt=""
                    class="mb-2"
                    @click="saveToExh('27CB21BD6EDBCBFEF20195FE647A48EE')"
                  />
                </a>
              </div>
            </div>
            <div class="col-lg-4 text-lg-left text-center">
              <a
                href="https://www.chanchao.com.tw/vietnamplasprintpack/onlineexpo/ExhibitorDetail/27CB21BD6EDBCBFEF20195FE647A48EE"
                target="_blank"
                class="text-primary "
                style="font-size:20px; "
                @click="saveToExh('27CB21BD6EDBCBFEF20195FE647A48EE')"
                >{{ ExhInfo_Asso_0.ComName }}</a
              >

              <p class="mt-2">
                Country: <span>{{ ExhInfo_Asso_0.Country }}</span>
              </p>
              <p>
                Category: <span>{{ ExhInfo_Asso_0.ExhibArea }}</span>
              </p>
            </div>
          </div>
          <p>&zwnj;</p>
        </div>
      </div>

      <!-- 1. Chamber of Commerce and Industry -->

      <div v-if="URLAssoID == 'ChamberofCommerceandIndustry'">
        <span class="title_fontStyle my-5 h2"> <i class="fas fa-caret-right"></i> Welcome Message </span>

        <div class="my-4 ">
          <div class="row  align-items-center px-4 pb-4 ">
            <div class="col-lg-4 text-center mb-2">
              <div class="logImgFrame_ExhInfo">
                <img src="../../assets/images/Association_VPA_01.jpg" width="70%" alt="" class="mb-2" />
              </div>
            </div>
            <div class="col-lg-8 text-lg-left text-center BannerHover" @click.prevent="OpenAssoDetail('AssoMessage01')">
              <h3>Chamber of Commerce and Industry</h3>

              <p class="mt-2">
                On behalf of media sponsor – Journal of Entrepreneurial Culture – a member of Vietnam Chamber of
                Commerce and Industry (VCCI)…
              </p>
              <p class="mt-3 text-primary">
                Read more
                <span class="ml-1"><i class="fas fa-angle-double-right " style="font-size:12px"></i></span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- 2. Vietnam Rubber Association -->

      <div v-if="URLAssoID == 'VietnamRubberAssociation'">
        <span class="title_fontStyle my-5 h2"> <i class="fas fa-caret-right"></i> Welcome Message </span>

        <div class="my-4 ">
          <div class="row  align-items-center px-4 pb-4 ">
            <div class="col-lg-4 text-center mb-2">
              <div class="logImgFrame_ExhInfo">
                <a
                  href="https://www.chanchao.com.tw/vietnamplasprintpack/onlineexpo/ExhibitorDetail/E7381BA5F9BBD44139B5FD7374976567"
                  target="_blank"
                >
                  <img
                    src="../../assets/images/Association_VPA_2.jpg"
                    width="70%"
                    alt=""
                    class="mb-2"
                    @click="saveToExh('E7381BA5F9BBD44139B5FD7374976567')"
                  />
                </a>
              </div>
            </div>
            <div class="col-lg-8 text-lg-left text-center BannerHover" @click.prevent="OpenAssoDetail('AssoMessage02')">
              <h3>Vietnam Rubber Association</h3>

              <p class="mt-2">
                As the official supporter of the Vietnam International Plastics & Rubber Industry Fair (VietnamPlas)…
              </p>

              <p class="mt-3 text-primary">
                Read more
                <span class="ml-1"><i class="fas fa-angle-double-right " style="font-size:12px"></i></span>
              </p>
            </div>
          </div>
        </div>

        <div>
          <span class="title_fontStyle my-5 h2"> <i class="fas fa-caret-right"></i> Exclusive Members </span>

          <div class="row align-items-center p-4  my-5">
            <div class="col-lg-4 text-center mb-2">
              <div class="logImgFrame_ExhInfo">
                <a
                  href="https://www.chanchao.com.tw/vietnamplasprintpack/onlineexpo/ExhibitorDetail/E7381BA5F9BBD44139B5FD7374976567"
                  target="_blank"
                >
                  <img
                    :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${ExhInfo_Asso_2_1.ComLogo}`"
                    width="52%"
                    alt=""
                    class="mb-2"
                    @click="saveToExh('E7381BA5F9BBD44139B5FD7374976567')"
                  />
                </a>
              </div>
            </div>
            <div class="col-lg-5 text-lg-left text-center">
              <a
                href="https://www.chanchao.com.tw/vietnamplasprintpack/onlineexpo/ExhibitorDetail/E7381BA5F9BBD44139B5FD7374976567"
                target="_blank"
                class="text-primary "
                style="font-size:20px; "
                @click="saveToExh('E7381BA5F9BBD44139B5FD7374976567')"
                >{{ ExhInfo_Asso_2_1.ComName }}</a
              >

              <p class="mt-2">
                Country: <span>{{ ExhInfo_Asso_2_1.Country }}</span>
              </p>
              <p>
                Category: <span>{{ ExhInfo_Asso_2_1.ExhibArea }}</span>
              </p>
            </div>
          </div>

          <div class="row align-items-center p-4  my-5">
            <div class="col-lg-4 text-center mb-2">
              <div class="logImgFrame_ExhInfo">
                <a
                  href="https://www.chanchao.com.tw/vietnamplasprintpack/onlineexpo/ExhibitorDetail/CFA82D9CD190B5125D4653E457231ADE"
                  target="_blank"
                >
                  <img
                    :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${ExhInfo_Asso_2_2.ComLogo}`"
                    width="52%"
                    alt=""
                    class="mb-2"
                    @click="saveToExh('CFA82D9CD190B5125D4653E457231ADE')"
                  />
                </a>
              </div>
            </div>
            <div class="col-lg-5 text-lg-left text-center">
              <a
                href="https://www.chanchao.com.tw/vietnamplasprintpack/onlineexpo/ExhibitorDetail/CFA82D9CD190B5125D4653E457231ADE"
                target="_blank"
                class="text-primary "
                style="font-size:20px; "
                @click="saveToExh('CFA82D9CD190B5125D4653E457231ADE')"
                >{{ ExhInfo_Asso_2_2.ComName }}</a
              >

              <p class="mt-2">
                Country: <span>{{ ExhInfo_Asso_2_2.Country }}</span>
              </p>
              <p>
                Category: <span>{{ ExhInfo_Asso_2_2.ExhibArea }}</span>
              </p>
            </div>
          </div>
          <p>&zwnj;</p>
        </div>
      </div>

      <!-- 3. Vietnam Printing Association -->

      <div v-if="URLAssoID == 'VietnamPrintingAssociation'">
        <span class="title_fontStyle my-5 h2"> <i class="fas fa-caret-right"></i> Welcome Message </span>

        <div class="my-4 ">
          <div class="row  align-items-center px-4 pb-4 ">
            <div class="col-lg-4 text-center mb-2">
              <div class="logImgFrame_ExhInfo">
                <img src="../../assets/images/Association_VPA_3.jpg" width="70%" alt="" class="mb-2" />
              </div>
            </div>
            <div class="col-lg-8 text-lg-left text-center BannerHover" @click.prevent="OpenAssoDetail('AssoMessage03')">
              <h3>Vietnam Printing Association</h3>

              <p class="mt-2">
                On behalf of Vietnam Printing Association, I warmly welcome organizations, enterprises…
              </p>

              <p class="mt-3 text-primary">
                Read more
                <span class="ml-1"><i class="fas fa-angle-double-right " style="font-size:12px"></i></span>
              </p>
            </div>
          </div>
        </div>

        <div>
          <span class="title_fontStyle my-5 h2"> <i class="fas fa-caret-right"></i> Exclusive Members </span>

          <div class="row align-items-center p-4  my-5">
            <div class="col-lg-4 text-center mb-2">
              <div class="logImgFrame_ExhInfo">
                <a
                  href="https://www.chanchao.com.tw/vietnamplasprintpack/onlineexpo/ExhibitorDetail/0990DDD47E1F304D16F1F430977DD361"
                  target="_blank"
                >
                  <img
                    :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${ExhInfo_Asso_3_1.ComLogo}`"
                    width="50%"
                    alt=""
                    class="mb-2"
                    @click="saveToExh('0990DDD47E1F304D16F1F430977DD361')"
                  />
                </a>
              </div>
            </div>
            <div class="col-lg-4 text-lg-left text-center">
              <a
                href="https://www.chanchao.com.tw/vietnamplasprintpack/onlineexpo/ExhibitorDetail/0990DDD47E1F304D16F1F430977DD361"
                target="_blank"
                class="text-primary "
                style="font-size:20px; "
                @click="saveToExh('0990DDD47E1F304D16F1F430977DD361')"
                >{{ ExhInfo_Asso_3_1.ComName }}</a
              >

              <p class="mt-2">
                Country: <span>{{ ExhInfo_Asso_3_1.Country }}</span>
              </p>
              <p>
                Category: <span>{{ ExhInfo_Asso_3_1.ExhibArea }}</span>
              </p>
            </div>
          </div>

          <div class="row align-items-center p-4  my-5">
            <div class="col-lg-4 text-center mb-2">
              <div class="logImgFrame_ExhInfo">
                <a
                  href="https://www.chanchao.com.tw/vietnamplasprintpack/onlineexpo/ExhibitorDetail/992B180864E6B641ECC736453F0509F2"
                  target="_blank"
                >
                  <img
                    :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${ExhInfo_Asso_3_2.ComLogo}`"
                    width="60%"
                    alt=""
                    class="mb-2"
                    @click="saveToExh('992B180864E6B641ECC736453F0509F2')"
                  />
                </a>
              </div>
            </div>
            <div class="col-lg-4 text-lg-left text-center">
              <a
                href="https://www.chanchao.com.tw/vietnamplasprintpack/onlineexpo/ExhibitorDetail/992B180864E6B641ECC736453F0509F2"
                target="_blank"
                class="text-primary "
                style="font-size:20px; "
                @click="saveToExh('992B180864E6B641ECC736453F0509F2')"
                >{{ ExhInfo_Asso_3_2.ComName }}</a
              >

              <p class="mt-2">
                Country: <span>{{ ExhInfo_Asso_3_2.Country }}</span>
              </p>
              <p>
                Category: <span>{{ ExhInfo_Asso_3_2.ExhibArea }}</span>
              </p>
            </div>
          </div>

          <p>&zwnj;</p>
        </div>
      </div>

      <!-- 4. Vietnam Packaging Association -->

      <div v-if="URLAssoID == 'VietnamPackagingAssociation'">
        <span class="title_fontStyle my-5 h2"> <i class="fas fa-caret-right"></i> Welcome Message </span>

        <div class="my-4 ">
          <div class="row  align-items-center px-4 pb-4 ">
            <div class="col-lg-4 text-center mb-2">
              <div class="logImgFrame_ExhInfo">
                <a
                  href="https://www.chanchao.com.tw/vietnamplasprintpack/onlineexpo/ExhibitorDetail/3EC93B258D41C01E16115608A04F9B15"
                  target="_blank"
                >
                  <img
                    src="../../assets/images/Association_VPA_4.jpg"
                    width="70%"
                    alt=""
                    class="mb-2"
                    @click="saveToExh('3EC93B258D41C01E16115608A04F9B15')"
                  />
                </a>
              </div>
            </div>
            <div class="col-lg-8 text-lg-left text-center BannerHover" @click.prevent="OpenAssoDetail('AssoMessage04')">
              <h3>Vietnam Packaging Association</h3>

              <p class="mt-2">
                Printing & Packaging industries play an important role – a driving force for the development of other
                industries…
              </p>

              <p class="mt-3 text-primary">
                Read more
                <span class="ml-1"><i class="fas fa-angle-double-right " style="font-size:12px"></i></span>
              </p>
            </div>
          </div>
        </div>

        <div>
          <span class="title_fontStyle my-5 h2"> <i class="fas fa-caret-right"></i> Exclusive Members </span>

          <div class="row align-items-center p-4  my-5">
            <div class="col-lg-4 text-center mb-2">
              <div class="logImgFrame_ExhInfo">
                <a
                  href="https://www.chanchao.com.tw/vietnamplasprintpack/onlineexpo/ExhibitorDetail/3EC93B258D41C01E16115608A04F9B15"
                  target="_blank"
                >
                  <img
                    :src="`https://www.chanchao.com.tw/exhibitorservicefiles/logo/${ExhInfo_Asso_4_1.ComLogo}`"
                    width="50%"
                    alt=""
                    class="mb-2"
                    @click="saveToExh('3EC93B258D41C01E16115608A04F9B15')"
                  />
                </a>
              </div>
            </div>
            <div class="col-lg-6 text-lg-left text-center">
              <a
                href="https://www.chanchao.com.tw/vietnamplasprintpack/onlineexpo/ExhibitorDetail/3EC93B258D41C01E16115608A04F9B15"
                target="_blank"
                class="text-primary "
                style="font-size:20px; "
                @click="saveToExh('3EC93B258D41C01E16115608A04F9B15')"
                >{{ ExhInfo_Asso_4_1.ComName }}</a
              >

              <p class="mt-2">
                Country: <span>{{ ExhInfo_Asso_4_1.Country }}</span>
              </p>
              <p>
                Category: <span>{{ ExhInfo_Asso_4_1.ExhibArea }}</span>
              </p>
            </div>
          </div>

          <div class="row align-items-center p-4  my-5">
            <div class="col-lg-4 text-center mb-2">
              <div class="logImgFrame_ExhInfo">
                <a
                  href="https://www.chanchao.com.tw/vietnamplasprintpack/onlineexpo/ExhibitorDetail/074FE0F470AA9A5500F810074947F3E1"
                  target="_blank"
                >
                  <img
                    :src="`https://www.chanchao.com.tw/exhibitorservicefiles/logo/${ExhInfo_Asso_4_2.ComLogo}`"
                    width="50%"
                    alt=""
                    class="mb-2"
                    @click="saveToExh('074FE0F470AA9A5500F810074947F3E1')"
                  />
                </a>
              </div>
            </div>
            <div class="col-lg-4 text-lg-left text-center">
              <a
                href="https://www.chanchao.com.tw/vietnamplasprintpack/onlineexpo/ExhibitorDetail/074FE0F470AA9A5500F810074947F3E1"
                target="_blank"
                class="text-primary "
                style="font-size:20px; "
                @click="saveToExh('074FE0F470AA9A5500F810074947F3E1')"
                >{{ ExhInfo_Asso_4_2.ComName }}</a
              >

              <p class="mt-2">
                Country: <span>{{ ExhInfo_Asso_4_2.Country }}</span>
              </p>
              <p>
                Category: <span>{{ ExhInfo_Asso_4_2.ExhibArea }}</span>
              </p>
            </div>
          </div>

          <div class="row align-items-center p-4  my-5">
            <div class="col-lg-4 text-center mb-2">
              <div class="logImgFrame_ExhInfo">
                <a
                  href="https://www.chanchao.com.tw/vietnamplasprintpack/onlineexpo/ExhibitorDetail/E2CEDA3DFDF2DD3AE3D9D4AD5E1B3BCD"
                  target="_blank"
                >
                  <img
                    :src="`https://www.chanchao.com.tw/exhibitorservicefiles/logo/${ExhInfo_Asso_4_3.ComLogo}`"
                    width="50%"
                    alt=""
                    class="mb-2"
                    @click="saveToExh('E2CEDA3DFDF2DD3AE3D9D4AD5E1B3BCD')"
                  />
                </a>
              </div>
            </div>
            <div class="col-lg-6 text-lg-left text-center">
              <a
                href="https://www.chanchao.com.tw/vietnamplasprintpack/onlineexpo/ExhibitorDetail/E2CEDA3DFDF2DD3AE3D9D4AD5E1B3BCD"
                target="_blank"
                class="text-primary "
                style="font-size:20px; "
                @click="saveToExh('E2CEDA3DFDF2DD3AE3D9D4AD5E1B3BCD')"
                >{{ ExhInfo_Asso_4_3.ComName }}</a
              >

              <p class="mt-2">
                Country: <span>{{ ExhInfo_Asso_4_3.Country }}</span>
              </p>
              <p>
                Category: <span>{{ ExhInfo_Asso_4_3.ExhibArea }}</span>
              </p>
            </div>
          </div>
          <p>&zwnj;</p>
        </div>
      </div>

      <!-- 5. Printing Association of Ho Chi Minh City -->

      <div v-if="URLAssoID == 'PrintingAssociationofHoChiMinhCity'">
        <span class="title_fontStyle my-5 h2"> <i class="fas fa-caret-right"></i> Welcome Message </span>

        <div class="my-4 ">
          <div class="row  align-items-center px-4 pb-4 ">
            <div class="col-lg-4 text-center mb-2">
              <div class="logImgFrame_ExhInfo">
                <img src="../../assets/images/Association_VPA_5.jpg" width="70%" alt="" class="mb-2" />
              </div>
            </div>
            <div class="col-lg-8 text-lg-left text-center BannerHover" @click.prevent="OpenAssoDetail('AssoMessage05')">
              <h3>Printing Association of Ho Chi Minh City</h3>

              <p class="mt-2">
                On behalf of Printing Association of Ho Chi Minh City, I warmly welcome organizations and enterprises…
              </p>

              <p class="mt-3 text-primary">
                Read more
                <span class="ml-1"><i class="fas fa-angle-double-right " style="font-size:12px"></i></span>
              </p>
            </div>
          </div>
        </div>

        <div>
          <span class="title_fontStyle my-5 h2"> <i class="fas fa-caret-right"></i> Exclusive Members </span>

          <div class="row align-items-center p-4  my-5">
            <div class="col-lg-4 text-center mb-2">
              <div class="logImgFrame_ExhInfo">
                <a
                  href="https://www.chanchao.com.tw/vietnamplasprintpack/onlineexpo/ExhibitorDetail/F412013B00D2420295695AA77F4B1322"
                  target="_blank"
                >
                  <img
                    :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${ExhInfo_Asso_5_1.ComLogo}`"
                    width="50%"
                    alt=""
                    class="mb-2"
                    @click="saveToExh('F412013B00D2420295695AA77F4B1322')"
                  />
                </a>
              </div>
            </div>
            <div class="col-lg-5 text-lg-left text-center">
              <a
                href="https://www.chanchao.com.tw/vietnamplasprintpack/onlineexpo/ExhibitorDetail/F412013B00D2420295695AA77F4B1322"
                target="_blank"
                class="text-primary "
                style="font-size:20px; "
                @click="saveToExh('F412013B00D2420295695AA77F4B1322')"
                >{{ ExhInfo_Asso_5_1.ComName }}</a
              >

              <p class="mt-2">
                Country: <span>{{ ExhInfo_Asso_5_1.Country }}</span>
              </p>
              <p>
                Category: <span>{{ ExhInfo_Asso_5_1.ExhibArea }}</span>
              </p>
            </div>
          </div>

          <div class="row align-items-center p-4  my-5">
            <div class="col-lg-4 text-center mb-2">
              <div class="logImgFrame_ExhInfo">
                <a
                  href="https://www.chanchao.com.tw/vietnamplasprintpack/onlineexpo/ExhibitorDetail/011A8B0EC915C04B9A856FD7A3C7C14C"
                  target="_blank"
                >
                  <img
                    :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${ExhInfo_Asso_5_2.ComLogo}`"
                    width="50%"
                    alt=""
                    class="mb-2"
                    @click="saveToExh('011A8B0EC915C04B9A856FD7A3C7C14C')"
                  />
                </a>
              </div>
            </div>
            <div class="col-lg-4 text-lg-left text-center">
              <a
                href="https://www.chanchao.com.tw/vietnamplasprintpack/onlineexpo/ExhibitorDetail/011A8B0EC915C04B9A856FD7A3C7C14C"
                target="_blank"
                class="text-primary "
                style="font-size:20px; "
                @click="saveToExh('011A8B0EC915C04B9A856FD7A3C7C14C')"
                >{{ ExhInfo_Asso_5_2.ComName }}</a
              >

              <p class="mt-2">
                Country: <span>{{ ExhInfo_Asso_5_2.Country }}</span>
              </p>
              <p>
                Category: <span>{{ ExhInfo_Asso_5_2.ExhibArea }}</span>
              </p>
            </div>
          </div>

          <!-- <div class="row align-items-center p-4  my-5">
            <div class="col-lg-4 text-center mb-2">
              <div class="logImgFrame_ExhInfo">
                <a
                  href="https://www.chanchao.com.tw/vietnamplasprintpack/onlineexpo/ExhibitorDetail/6F3A62EDB7F514115817CE1F3CA18C07"
                  target="_blank"
                >
                  <img
                    :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${ExhInfo_Asso_5_3.ComLogo}`"
                    width="50%"
                    alt=""
                    class="mb-2"
                    @click="saveToExh('6F3A62EDB7F514115817CE1F3CA18C07')"
                  />
                </a>
              </div>
            </div>
            <div class="col-lg-5 text-lg-left text-center">
              <a
                href="https://www.chanchao.com.tw/vietnamplasprintpack/onlineexpo/ExhibitorDetail/6F3A62EDB7F514115817CE1F3CA18C07"
                target="_blank"
                class="text-primary "
                style="font-size:20px; "
                @click="saveToExh('6F3A62EDB7F514115817CE1F3CA18C07')"
                >{{ ExhInfo_Asso_5_3.ComName }}</a
              >

              <p class="mt-2">
                Country: <span>{{ ExhInfo_Asso_5_3.Country }}</span>
              </p>
              <p>
                Category: <span>{{ ExhInfo_Asso_5_3.ExhibArea }}</span>
              </p>
            </div>
          </div> -->
          <p>&zwnj;</p>
        </div>
      </div>

      <!-- 彈跳視窗 -->

      <div
        class="modal fade"
        id="AssoModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLongTitle"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg " role="document">
          <!-- OrganizerAsso -->
          <div class="modal-content" v-if="AssoNo == 'OrganMessage'">
            <div class="modal-header">
              <h3 class="modal-title title_fontStyle" id="exampleModalLongTitle">
                Welcome Message
              </h3>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body my-2  " style="font-family:Times New Roman">
              <div class="text-center">
                <a
                  :href="`https://www.youtube.com/embed/sDuWBK6xHAE`"
                  frameborder="0"
                  allow="autoplay; encrypted-media"
                  data-fancybox
                  data-width="1280"
                  data-height="720"
                >
                  <img
                    :src="`https://img.youtube.com/vi/sDuWBK6xHAE/hqdefault.jpg`"
                    class="BannerHover img-fluid"
                    width="500px"
                    data-toggle="tooltip"
                    data-placement="right"
                    title="Watch Video"
                    alt=""
                  />
                </a>
              </div>

              <p class="my-2 text-center" style="font-size:15px">
                <i class="far fa-play-circle mr-1"></i>
                Please click the image above to watch the full version of this video
              </p>

              <hr />

              <div class="d-flex  justify-content-around font-weight-bold mt-2">
                <div>
                  VIETNAM PLASTICS ASSOCIATION
                </div>

                <div>
                  <p>THE SOCIALIST REPUBLIC OF VIETNAM</p>
                  <p class="mr-4" style="font-style:italic;">Independence – Freedom – Happiness</p>
                </div>
              </div>

              <h3 class="text-center font-weight-bold mt-5">
                WELCOME LETTER
              </h3>

              <p
                class="mt-3"
                v-html="
                  `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Vietnam’s plastic industry plays an extremely important role in the economic development with an annual growth of 12%-15% and a turnover of US$ 20 billion. The local plastic industry also creates a driving force for development of other industries. In the past time, Vietnam’s plastics industry has made outstanding progresses through high quality products capable of meeting business and production demands locally and internationally. However, it is a common situation of almost local enterprises that lacks of modern technology while equipment and machinery are outdated.`
                "
              ></p>

              <p
                class="mt-2"
                v-html="
                  `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;In order to meet innovation requirement of Vietnam’s plastic industry and to enhance business competitiveness, Vietnam National Trade Fair and Advertising JSC (VINEXAD) is in corporation with Yorkers Vietnam to organize the “VietnamPlas Online Expo” from December 1-10 2021. `
                "
              ></p>

              <p
                class="mt-2"
                v-html="
                  `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;As a national organization representing Vietnam’s plastic business community, Vietnam Plastics Association believes that this event will surely bring useful information, help local enterprises update the world’s technology trends, enhance competitiveness and sustainable efficiency for Vietnam’s economy in the coming time. `
                "
              ></p>

              <p
                class="mt-2"
                v-html="
                  `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Vietnam Plastics Association would like thank Ministries, Agencies, Associations, local authorities for their support for the success of the event for many years. We wish exhibitors and visitors reap useful results. Wish the event a great success.`
                "
              ></p>

              <div class="row mt-2">
                <div class="col-lg-7"></div>

                <div class="col-lg-5">
                  <div class="font-weight-bold text-center">
                    <p>
                      VIETNAM PLASTICS ASSOCIATION
                    </p>
                    <p>
                      CHAIRMAN
                    </p>
                    <p>
                      HO DUC LAM
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Asso01 -->
          <div class="modal-content" v-if="AssoNo == 'AssoMessage01'">
            <div class="modal-header">
              <h3 class="modal-title title_fontStyle" id="exampleModalLongTitle">
                Welcome Message
              </h3>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body my-2">
              <div class="text-center">
                <a
                  :href="`https://www.youtube.com/embed/8f2A3lX8s1U`"
                  frameborder="0"
                  allow="autoplay; encrypted-media"
                  data-fancybox
                  data-width="1280"
                  data-height="720"
                >
                  <img
                    :src="`https://img.youtube.com/vi/8f2A3lX8s1U/hqdefault.jpg`"
                    class="BannerHover img-fluid"
                    width="700px"
                    data-toggle="tooltip"
                    data-placement="right"
                    title="Watch Video"
                    alt=""
                  />
                </a>
              </div>

              <p class="my-2 text-center" style="font-size:15px">
                <i class="far fa-play-circle mr-1"></i>
                Please click the image above to watch the full version of this video
              </p>
            </div>
          </div>

          <!-- Asso02 -->
          <div class="modal-content" v-if="AssoNo == 'AssoMessage02'">
            <div class="modal-header">
              <h3 class="modal-title title_fontStyle" id="exampleModalLongTitle">
                Welcome Message
              </h3>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body my-2  text-center">
              <img src="../../assets/images/Asso_WM_02.jpg" width="600px" class="img-fluid" alt="" />
            </div>
          </div>

          <!-- Asso03 -->
          <div class="modal-content" v-if="AssoNo == 'AssoMessage03'">
            <div class="modal-header">
              <h3 class="modal-title title_fontStyle" id="exampleModalLongTitle">
                Welcome Message
              </h3>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body my-2  " style="font-family:Times New Roman">
              <h3 class="text-center font-weight-bold">
                Vietnam Printing Association
              </h3>

              <p
                class="mt-3"
                v-html="
                  `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;On behalf of Vietnam Printing Association, I warmly welcome organizations, enterprises
                to participate in “VietnamPrintPack Online Expo” co-organized by Vietnam National Trade Fair and
                Advertising JSC and Yorkers Vietnam taken place from December 1 to 10, 2021.`
                "
              ></p>

              <p
                class="mt-3"
                v-html="
                  `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;The printing and packaging industry is an important one and considered as foundation
                for industries in particular and of the entire economic sector in general, despite difficulties, the
                printing and packaging industry has made ceaseless efforts in overcoming, creating initial changes in
                some fields. The achieved results of the printing and packaging industry have contributed to the
                socio-economic development and strengthened the process of national modernization and industrialization.
                In order to facilitate the development of printing and packaging industry, enterprises need to
                strengthen investment, technology and equipment innovation, modernization of manufacturing technology,
                effective production. These are essential requirements for each enterprise in today’s development trend.`
                "
              ></p>

              <p
                class="mt-3"
                v-html="
                  `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Vietnam Printing Association believes that “VietnamPrintPack Online Expo” will
                be an opportunity for manufacturers and businesses in the Vietnam printing and packaging industry to
                access advanced technology, science and technique to maximize their production capacity, business
                efficiency, contributing to the growth of Vietnam industry, meeting requirements of domestic production
                and serving for export.`
                "
              ></p>

              <p
                class="mt-3"
                v-html="
                  `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;We wish the “VietnamPrintPack Online Expo” a great success!`
                "
              ></p>

              <p class="mt-3 text-right font-weight-bold" style="margin-right:32px">
                CHAIRMAN
              </p>
              <p class=" text-right font-weight-bold">
                NGUYEN VAN DONG
              </p>
            </div>
          </div>

          <!-- Asso04 -->
          <div class="modal-content" v-if="AssoNo == 'AssoMessage04'">
            <div class="modal-header">
              <h3 class="modal-title title_fontStyle" id="exampleModalLongTitle">
                Welcome Message
              </h3>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body my-2  " style="font-family:Times New Roman">
              <div class="d-flex align-items-center justify-content-around font-weight-bold">
                <div>
                  <img src="../../assets/images/Asso_WM_04.jpg" width="140px" alt="" />
                </div>

                <div>
                  <p>THE SOCIALIST REPUBLIC OF VIETNAM</p>
                  <p class="mr-4" style="font-style:italic;">Independence – Freedom – Happiness</p>
                </div>
              </div>

              <h3 class="text-center font-weight-bold mt-5">
                WELCOME LETTER
              </h3>

              <p
                class="mt-3"
                v-html="
                  `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Printing & Packaging industries play an important role – a driving force for the development of other industries. Recently, the domestic printing and packaging industries have made great progress with many products capable of meeting business and production requirements. However, the lack of technology, outdated equipment and machinery are amongst difficulties of almost printing and packaging enterprises.`
                "
              ></p>

              <p
                class="mt-2"
                v-html="
                  `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;In order to meet the demand of innovation of Vietnam’s industry and enhance the competitiveness of enterprises, VINEXAD is collaborating with Yorkers Vietnam to organize “VietnamPrintPack Online Expo” on December 1 to 10, 2021.`
                "
              ></p>

              <p
                class="mt-2"
                v-html="
                  `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;As a national organization representing Vietnamese business community, VINEXAD & Yorkers Vietnam believe that this event will help enhance competitiveness and sustainable efficiency for Vietnam’s economy in the coming time.`
                "
              ></p>

              <p
                class="mt-2"
                v-html="
                  `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;We would like to express our thanks to Ministries, Departments, Associations and local leaders for your kind support for “VietnamPrintPack Online Expo”. We wish you all, especially exhibitors and visitors, to achieve useful results at the event.`
                "
              ></p>

              <p
                class="mt-2"
                v-html="
                  `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;We wish “VietnamPrintPack Online Expo” a great success!`
                "
              ></p>

              <p class="mt-3 text-right font-weight-bold" style="margin-right:32px">
                CHAIRMAN
              </p>
              <p class=" text-right font-weight-bold">
                NGUYEN NGOC SANG
              </p>
            </div>
          </div>

          <!-- Asso05 -->
          <div class="modal-content" v-if="AssoNo == 'AssoMessage05'">
            <div class="modal-header">
              <h3 class="modal-title title_fontStyle" id="exampleModalLongTitle">
                Welcome Message
              </h3>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body my-2" style="font-family:Times New Roman">
              <div class="font-weight-bold d-flex justify-content-between">
                <div>
                  PRINTING ASSOCIATION OF HOCHIMINH CITY
                </div>
                <div>
                  THE SOCIALIST REPUBLIC OF VIETNAM
                </div>
              </div>
              <p class="text-right mr-4" style="font-style:italic">
                Independence – Freedom - Happiness
              </p>

              <h3 class="text-center font-weight-bold my-4">
                WELCOME LETTER
              </h3>

              <p
                class="mt-3"
                v-html="
                  `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;On behalf of Printing Association of Ho Chi Minh City, I warmly welcome organizations and enterprises to participate in “VietnamPrintPack Online Expo” co-organized by Vietnam National Trade Fair and Advertising JSC and Yorkers Vietnam taken place from December 1 to 10, 2021.`
                "
              ></p>

              <p
                class="mt-3"
                v-html="
                  `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;The continuous development of printing and packaging industry has ignited the innovation of equipment, machinery, production technology to enhance productivity, quality and efficiency. The technology of printing and packaging industry will bring opportunities for developed countries, step by step narrowing the gap in production capacity and technology for developing countries. Printing Association of Ho Chi Minh City believes that the event will be a platform to display products, technology and exchange experiences for enterprises, seek market, expand business and investment cooperation. `
                "
              ></p>

              <p
                class="mt-3"
                v-html="
                  `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Printing Association of Ho Chi Minh City hopes that the “VietnamPrintPack Online Expo” will bring a lot of equipment, solutions, advanced technology to meet the demand of Vietnam market.`
                "
              ></p>

              <p
                class="mt-3"
                v-html="
                  `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;We wish you all success at the exhibition! `
                "
              ></p>

              <p class="mt-3 text-right font-weight-bold" style="margin-right:17px">
                CHAIRMAN
              </p>
              <p class=" text-right font-weight-bold">
                NGO ANH TUAN
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LobbyNavbar from '@/components/LobbyNavbar.vue'
  import $ from 'jquery'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      LobbyNavbar,
    },

    data() {
      return {
        token: '',
        DateStatus: 0,
        AssoNo: '',
        URLAssoID: '', //URL參數值

        ExhInfo_Asso_0: {},
        ExhInfo_Asso_2_1: {},
        ExhInfo_Asso_2_2: {},
        ExhInfo_Asso_3_1: {},
        ExhInfo_Asso_3_2: {},
        ExhInfo_Asso_4_1: {},
        ExhInfo_Asso_4_2: {},
        ExhInfo_Asso_4_3: {},
        ExhInfo_Asso_5_1: {},
        ExhInfo_Asso_5_2: {},
        ExhInfo_Asso_5_3: {},
      }
    },

    computed: {
      ...mapGetters(['ListStatus', 'Roomvisible', 'ShowRoom', 'exhcode']),
    },

    methods: {
      OpenAssoDetail(No) {
        this.AssoNo = No
        $('#AssoModal').modal('show')
      },

      //瀏覽紀錄

      saveToExh(ExhID) {
        const vm = this

        //紀錄瀏覽
        vm.$http.get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/CSRF_Token`).then((response) => {
          let CSRFToken = response.data
          let NowPageUrl = location.href

          const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
          const info = {
            Type: 'RNO',
            ID: ExhID,
            Url: NowPageUrl,
            CSRF: CSRFToken,
            RegNo: ExhID,
          }

          vm.$http.post(url, info).then(function(response) {
            if (response.data == '200') {
              console.log('Log success')
            } else if (response.data == '251') {
              console.log('Log fail')
            }
          })
        })
      },
    },

    created() {
      $('.modal').modal('hide')
      const vm = this
      this.$store.dispatch('ShowChatRoom', false)

      this.$store.dispatch('updateList', false)
      this.$store.dispatch('Updatevisible', true)

      vm.URLAssoID = vm.$route.params.MyAssoId

      //取得參展商Profile資料

      //0. Vietnam Plastics Association

      if (vm.URLAssoID == 'VietnamPlasticsAssociation') {
        vm.$http
          .get(
            `https://www.chanchao.com.tw/apiOnlineExpo/v1/ExhibitorsDetail/${vm.exhcode}/27CB21BD6EDBCBFEF20195FE647A48EE?Lang=en`
          )
          .then((response) => {
            vm.ExhInfo_Asso_0 = response.data
          })
      } else if (vm.URLAssoID == 'ChamberofCommerceandIndustry') {
      } else if (vm.URLAssoID == 'VietnamRubberAssociation') {
        //2. Vietnam Rubber Association_2_1
        vm.$http
          .get(
            `https://www.chanchao.com.tw/apiOnlineExpo/v1/ExhibitorsDetail/${vm.exhcode}/E7381BA5F9BBD44139B5FD7374976567?Lang=en`
          )
          .then((response) => {
            vm.ExhInfo_Asso_2_1 = response.data

            //2. Vietnam Rubber Association_2_2
            vm.$http
              .get(
                `https://www.chanchao.com.tw/apiOnlineExpo/v1/ExhibitorsDetail/${vm.exhcode}/CFA82D9CD190B5125D4653E457231ADE?Lang=en`
              )
              .then((response) => {
                vm.ExhInfo_Asso_2_2 = response.data
              })
          })
      } else if (vm.URLAssoID == 'VietnamPrintingAssociation') {
        //3. Vietnam Printing Association_3_1
        vm.$http
          .get(
            `https://www.chanchao.com.tw/apiOnlineExpo/v1/ExhibitorsDetail/${vm.exhcode}/0990DDD47E1F304D16F1F430977DD361?Lang=en`
          )
          .then((response) => {
            vm.ExhInfo_Asso_3_1 = response.data

            //2. Vietnam Printing Association_3_2
            vm.$http
              .get(
                `https://www.chanchao.com.tw/apiOnlineExpo/v1/ExhibitorsDetail/${vm.exhcode}/992B180864E6B641ECC736453F0509F2?Lang=en`
              )
              .then((response) => {
                vm.ExhInfo_Asso_3_2 = response.data
              })
          })
      } else if (vm.URLAssoID == 'VietnamPackagingAssociation') {
        //4. Vietnam Packaging Association_4_1
        vm.$http
          .get(
            `https://www.chanchao.com.tw/apiOnlineExpo/v1/ExhibitorsDetail/${vm.exhcode}/3EC93B258D41C01E16115608A04F9B15?Lang=en`
          )
          .then((response) => {
            vm.ExhInfo_Asso_4_1 = response.data

            //4. Vietnam Packaging Association_4_2
            vm.$http
              .get(
                `https://www.chanchao.com.tw/apiOnlineExpo/v1/ExhibitorsDetail/${vm.exhcode}/074FE0F470AA9A5500F810074947F3E1?Lang=en`
              )
              .then((response) => {
                vm.ExhInfo_Asso_4_2 = response.data

                //4.Vietnam Packaging Association_4_3
                vm.$http
                  .get(
                    `https://www.chanchao.com.tw/apiOnlineExpo/v1/ExhibitorsDetail/${vm.exhcode}/E2CEDA3DFDF2DD3AE3D9D4AD5E1B3BCD?Lang=en`
                  )
                  .then((response) => {
                    vm.ExhInfo_Asso_4_3 = response.data
                  })
              })
          })
      } else if (vm.URLAssoID == 'PrintingAssociationofHoChiMinhCity') {
        //5. PrintingAssociationofHoChiMinhCity_5_1
        vm.$http
          .get(
            `https://www.chanchao.com.tw/apiOnlineExpo/v1/ExhibitorsDetail/${vm.exhcode}/F412013B00D2420295695AA77F4B1322?Lang=en`
          )
          .then((response) => {
            vm.ExhInfo_Asso_5_1 = response.data

            //5. PrintingAssociationofHoChiMinhCity_5_2
            vm.$http
              .get(
                `https://www.chanchao.com.tw/apiOnlineExpo/v1/ExhibitorsDetail/${vm.exhcode}/011A8B0EC915C04B9A856FD7A3C7C14C?Lang=en`
              )
              .then((response) => {
                vm.ExhInfo_Asso_5_2 = response.data

                //5. PrintingAssociationofHoChiMinhCity_5_3
                vm.$http
                  .get(
                    `https://www.chanchao.com.tw/apiOnlineExpo/v1/ExhibitorsDetail/${vm.exhcode}/6F3A62EDB7F514115817CE1F3CA18C07?Lang=en`
                  )
                  .then((response) => {
                    vm.ExhInfo_Asso_5_3 = response.data
                  })
              })
          })
      }

      //紀錄瀏覽

      vm.$http.get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/CSRF_Token`).then((response) => {
        let CSRFToken = response.data

        let NowPageUrl = location.href

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: NowPageUrl,
          CSRF: CSRFToken,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            console.log('Log success')
          } else if (response.data == '251') {
            console.log('Log fail')
          }
        })
      })
    },
  }
</script>

<style lang="scss" scoped>
  .UserFrame {
    border: 1px solid rgb(228, 226, 226);
    border-radius: 20px;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 30px;
    padding-right: 30px;
  }

  .sticky-top {
    position: sticky;
    top: 100px;
    z-index: 1020;
  }

  .font_Name {
    font-size: 18px;
    font-weight: 500;
  }

  .Asso-effect {
    border-radius: 0.25rem;

    &:hover {
      box-shadow: 1px 1px 8px 1px #dedede;
      filter: brightness(1.1);
      cursor: pointer;
    }
  }
</style>
